import React from 'react';
import '../assets/css/spinner.css';

const LoadingSpinner = ({ text = 'Loading...' }) => {
  return (
    <div className="spinner-container">
      <div>
        <div className="spinner" />
        <p className="loading-text">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
